import {postMethod} from '~/api'

async function post(packageId, request) {
    return await postMethod(`/api/ownPackageContracts/${packageId}/itinerary/swap`, request)
}

export {post}
